import { render, staticRenderFns } from "./RegistrationDrivingLicenseStep.vue?vue&type=template&id=41061c48&lang=pug&"
import script from "./RegistrationDrivingLicenseStep.vue?vue&type=script&lang=ts&"
export * from "./RegistrationDrivingLicenseStep.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationDrivingLicenseStep.vue?vue&type=style&index=0&id=41061c48&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports